import Store from "App/Store.js";

import dFeaturesForced from "./dFeaturesForced.js";

export default () => {
	Store.dispatch({type: "auth", auth: null});
	dFeaturesForced([]);
};
